import React, { useState } from 'react';

type SearchBarProps = {
    onSearch: (query: string) => void;
    onQueryChange?: (query: string) => void;
};

const SearchBar: React.FC<SearchBarProps> = ({ onSearch, onQueryChange }) => {
    const [query, setQuery] = useState('');

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const next = event.target.value;
        setQuery(next);
        if (onQueryChange) onQueryChange(next);
    };

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        onSearch(query);
    };

    const handleClear = () => {
        setQuery('');
        if (onQueryChange) onQueryChange('');
    };

    return (
        <form onSubmit={handleSubmit} className="header-search">
            <div className="input-wrapper">
            <input
                type="text"
                value={query}
                onChange={handleInputChange}
                    placeholder="Search digital products or services..."
            />
                {query && (
                    <button
                        type="button"
                        className="clear-btn"
                        onClick={handleClear}
                        aria-label="Clear search"
                        title="Clear"
                    >
                        ×
                    </button>
                )}
            </div>
            <button type="submit">Search</button>
        </form>
    );
};

export default SearchBar;